import styled, { css } from 'styled-components';
import { TStyledBadgeProperties } from './badge.types';

export const StyledBadge = styled.div<TStyledBadgeProperties>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2rem;
    min-height: 2rem;
    padding: 0 0.5rem;
    color: ${({ theme }) => theme.color.white};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: ${({ theme }) => theme.font.size.small};
    font-family: ${({ theme }) => theme.font.family.primary};
    line-height: 1.8rem;
    vertical-align: ${({ alignment }) => alignment};
    background-color: ${({ theme, color }) => theme.color[color]};
    border: 0.1rem solid ${({ theme, color }) => theme.color[color]};
    border-radius: 1rem;

    ${({ theme, badgeType }) => {
        if (badgeType === 'default') {
            return css`
                box-shadow: ${theme.shadow.low};
                border-color: ${theme.color.white};
            `;
        }
    }}
`;
